import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRole = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      const { data, error } = await supabase?.from('role_email_authorizations')?.select('role')?.eq('email', user?.email)?.limit(1);

      if (error) {
        console.error('Error fetching user role:', error);
      } else {
        setUserRole(data?.[0]?.role?.toLowerCase());
      }

      setLoading(false);
    };

    fetchRole();
  }, [user]);

  if (loading) return <p>Loading...</p>;

  if (!user) return <Navigate to="/user-login" replace />;

  // Check if the user's role matches one of the allowed roles
  if (!allowedRoles?.map(r => r?.toLowerCase())?.includes(userRole)) {
    console.warn(`Access denied. User role "${userRole}" not allowed.`);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;